import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiFactory, getIdCidade, setAuthToken } from '../../api/apiFactory';
import { fetchLimparCookie, fetchVerificarAnonimo } from '../../api/endpoints';
import {
  FAILED, IDLE, LOADING, SUCCEEDED,
} from '../constants';

const initialState = {
  data: null,
  status: IDLE,
  error: null,
};

export const fetchLogin = createAsyncThunk('login/fetchLogin', async ({ username, password }) => {
  const passwordEncoded = encodeURIComponent(password);
  const body = `username=${username}&id=${await getIdCidade()}&grant_type=password&password=${passwordEncoded}`;

  const resposta = await apiFactory('/token', {
    method: 'post',
    headers: { 'content-type': 'www-url-form-encoded' },
    body,
  });

  if (resposta.error) {
    return resposta.error;
  }

  setAuthToken(resposta.access_token);

  const validacao = await fetchVerificarAnonimo();

  const credenciais = ({
    token: resposta.access_token,
    anonimo: validacao.Message,
  });

  return credenciais;
});

export const fetchLoginAnonimo = createAsyncThunk('login/fetchLoginAnonimo', async ({ modulo }) => {
  const body = `id=${await getIdCidade()}&anonimo=S&modulo=${modulo}&grant_type=password`;
  const resposta = await apiFactory('/token', {
    method: 'post',
    headers: { 'content-type': 'www-url-form-encoded' },
    body,
  });
  setAuthToken(resposta.access_token);

  const validacao = await fetchVerificarAnonimo();

  const credenciais = ({
    token: resposta.access_token,
    anonimo: validacao.Message,
  });

  return credenciais;
});

const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    realizarConexao(state, action) {
      state.login.push(action.payload);
    },
    desfazerConexao(state) {
      state.data = null;
      fetchLimparCookie();
    },
  },
  extraReducers: {
    [fetchLogin.pending]: (state) => {
      state.status = LOADING;
    },
    [fetchLogin.fulfilled]: (state, action) => {
      state.status = SUCCEEDED;
      state.data = action.payload;
    },
    [fetchLogin.rejected]: (state, action) => {
      state.status = FAILED;
      state.error = action.error.message;
    },
    [fetchLoginAnonimo.pending]: (state) => {
      state.status = LOADING;
    },
    [fetchLoginAnonimo.fulfilled]: (state, action) => {
      state.status = SUCCEEDED;
      state.data = action.payload;
    },
    [fetchLoginAnonimo.rejected]: (state, action) => {
      state.status = FAILED;
      state.error = action.error.message;
    },
  },
});

export const selectLogin = (state) => state.login;

export const { realizarConexao, desfazerConexao } = loginSlice.actions;

export default loginSlice.reducer;
